module.exports = __webpack_public_path__ + "img/marker_vms.578cf128.svg";